export * from "./datepicker";
export * from "./formulasMode";
export * from "./stack";
export * from "./linkBuilder";

export function setApiURL(path: string) {
    return `${process.env.PEPPERMINT_URL}/${path}`;
}
